import React from "react";
import PropTypes from "prop-types";
import "./member-icon-new.scss";
import { FluentAvatar } from "../FluentUI/Fluent-Avatar";

const MemberIconNew = ({ type, member, extraMembers = 0, isGroup = false, isGroupIcon }) => {
  const safeMember = member || {};
  const safeUser = safeMember.User || {};
  const safeGroup = safeMember.Group || {};
  let Name = safeUser.Name || safeMember.Name || safeGroup.Name || "";
  let className = "";
  switch (type) {
    case "user":
      className = "task-member-user";
      break;
    case "creator":
      className = "task-member-creator";
      break;
    case "extra":
      className = "task-member-extra";
      if (extraMembers > 98) {
        Name = '99+';
      } else {
        Name = `+${extraMembers}`;
      }
      break;
    default:
      className = "project-member-user";
      break;
  }
  return (
    type === "extra" ?
      <FluentAvatar size={28} initials={Name} className={`${className}`} />
      :
      <FluentAvatar size={28} name={Name} className={`${className} ${(isGroupIcon || isGroup) ? "isGroup" : ""}`} />
  );
};

MemberIconNew.propTypes = {
  member: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    Initials: PropTypes.string.isRequired,
    User: PropTypes.shape({
      Name: PropTypes.string.isRequired,
      Initials: PropTypes.string.isRequired,
    }),
  }).isRequired,
  isGroupIcon: PropTypes.bool,
};

export default MemberIconNew;
